import { useState, useEffect } from "react";
import { Button } from "../../ui/Button/Button"
import { Text } from "../../ui/Text/Text"
import { getEditModeItemsQuantity, getEditModeLineItems, getLineItems, stopEditingMode } from "./utils";
import { isEditMode, isPos } from "../../../utils";
import { useApp } from "../../../hooks/useApp";

interface Props {
  className?: string
}

export const AddToCartButton = ({ className}: Props) => {
  const { mainProduct, activeMainProductVariantId, activePendantProductVaraintIds, cart} = useApp()
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error" | "copy" | "copied">(
      "idle"
    );

  useEffect(() => {
    if (isPos()) {
      setStatus("copy")
    }
  }, [])

  async function copyToClipboard(text: string) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (e) {
      console.error(e);
    }
  }

  const handleAddToCart = async () => {
    setStatus("loading");

    const quantity = isEditMode()
      ? getEditModeItemsQuantity()
      : 1

    const itemsToAdd = getLineItems(mainProduct, activeMainProductVariantId, activePendantProductVaraintIds, quantity)
    const itemsToRemove = getEditModeLineItems(cart)
  
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("pos")) {
      const formattedItems = itemsToAdd.map(itemToAdd => {
        const { id, ...rest } = itemToAdd;
        return { variantId: Number(id), ...rest };
      });

      copyToClipboard(JSON.stringify(formattedItems));
      setStatus("copied");
      setTimeout(() => setStatus("copy"), 5000)
      return;
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }

    const addItems = () => fetch("/cart/add.js", { 
      ...requestOptions,
      body: JSON.stringify({ items: itemsToAdd }),
    })

    const removeItems = () => fetch("/cart/update.js", { 
      ...requestOptions,
      body: JSON.stringify({ updates: itemsToRemove }),
    })

    Promise.all([
      addItems(), 
      itemsToRemove && removeItems()
    ])
      .then(res => {
        const [addItemsRes, removeItemsRes] = res;
        if (!addItemsRes.ok || removeItemsRes !== null && !removeItemsRes.ok) throw new Error("Failed to update cart")
      })
      .then(() => {
        setStatus("success");

        document.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: {
                name: mainProduct.title
              },
              quantity
            }
          })
        )

        isEditMode() && stopEditingMode()

        setTimeout(() => setStatus("idle"), 2000);
      })
      .catch((err) => {
         console.error(err);
        setStatus("error");
        setTimeout(() => setStatus("idle"), 2000);
      })
  };

  return (
    <Button className={className} size="md" color="black" disabled={status === "loading"} onClick={handleAddToCart}>
      <Text style="label">
        {status === "loading"
          ? "•••"
          : status === "error"
          ? "Error"
          : status === "copied"
          ? "Copied"
          : status === "copy"
          ? "Copy IDs"
          : isEditMode()
          ? "Edit"
          : "Add to Bag"
        }
      </Text>
    </Button>
  )
}